import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  sucursales: z.array(z.object({
    label: z.string()
  })).nonempty('Debes tener al menos una sucursal').refine((value) => value.length > 0, 'Debes tener al menos una sucursal'),
})